module.exports = __webpack_public_path__ + "static/media/bigred.d5e793e7.png";